import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/shared/Button/Button';
import Modal from '../../../../components/shared/Modal/Modal';
import { IsMobile } from '../../../../helpers/IsMobile';

import styles from './IneligibleModal.module.scss';

const IneligibleModal = ({ showModal, closeModal, reasons }) => {
  const { t } = useTranslation('common');
  const modalFullScreen = IsMobile();

  const primaryReasons = useMemo(
    () => reasons.map(({ reason, employment_period }) => ({ reason, employment_period })),
    [reasons]
  );

  const additionalReasons = useMemo(() => {
    const additionalArray = reasons.map(({ additional_info }) => additional_info);
    return additionalArray.filter((i) => !!i);
  }, [reasons]);

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={modalFullScreen}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('ineligible.rewardMarkedIneligible')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.ineligibleContent}>
          <p className={styles.heading}>{t('ineligible.reasonsHeading')}</p>
          <ul>
            {primaryReasons.map(({ reason, employment_period }) => (
              <li key={reason} className={styles.text}>
                {reason}
                {!!employment_period && (
                  <span>
                    &nbsp;-&nbsp;<u>{t('ineligible.employmentPeriodDays', { days: employment_period })}</u>
                  </span>
                )}
              </li>
            ))}
          </ul>
          {!!additionalReasons.length && (
            <>
              <p className={styles.heading}>{t('ineligible.additionalInfo')}</p>
              {additionalReasons.map((message) => (
                <p className={styles.text} key={message}>
                  {message}
                </p>
              ))}
            </>
          )}
          <p className={styles.info}>{t('ineligible.disputeInfo')}</p>
          <div className={styles.btnCont}>
            <Button onClick={closeModal}>{t('buttons.okay')}</Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IneligibleModal;
